import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { QuoteMediaEodPriceJobsTable } from '../../../../../../../../../../features/vendor/quotemedia/eod-price/job/quotemedia-eod-price-jobs-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorQuoteMedia,
      label: 'Jobs',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorQuoteMedia>,
  head: () => getPageHead('QuoteMedia EOD Price Jobs'),
  component: QuoteMediaEodPriceJobsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorQuoteMedia}
    />
  );
}

function QuoteMediaEodPriceJobsList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <QuoteMediaEodPriceJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
